export const ENV = {
    API_BASE_URL: process.env.EXPO_PUBLIC_API_BASE_URL!,
    STREAM_API_KEY: process.env.EXPO_PUBLIC_STREAM_API_KEY!,
    STREAM_PUSH_PROVIDER_IOS: process.env.EXPO_PUBLIC_STREAM_PUSH_PROVIDER_IOS!,
    STREAM_PUSH_PROVIDER_ANDROID: process.env.EXPO_PUBLIC_STREAM_PUSH_PROVIDER_ANDROID!,
    LIVEKIT_URL: process.env.EXPO_PUBLIC_LIVEKIT_URL!,
    // Optional — Sentry disables itself when the DSN is missing.
    SENTRY_DSN: process.env.EXPO_PUBLIC_SENTRY_DSN,
    DEV_STREAM_USER: 'test',
    DEV_STREAM_TOKEN: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoidGVzdCJ9.F9cCGkvFxpFZR8shUCo9Xg_e52BZMqNpgAl7kL6_q5U',//dev only
};